// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nGuHvddX{font-size:.88rem;gap:.36em;padding:1.1em 0 1.9em}.wtpCQuUj{gap:.51em}._4T48dvf4{font-size:1em;line-height:1.8}.TPtaMZse{font-size:.71em!important}.zZ25nB6y{font-size:.86em;line-height:1.17}@media(max-width:1365.98px){.zV8cg9CY{gap:.75rem;height:auto!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head": "nGuHvddX",
	"hallContainer": "wtpCQuUj",
	"hall": "_4T48dvf4",
	"label": "TPtaMZse",
	"description": "zZ25nB6y",
	"sessions": "zV8cg9CY"
};
module.exports = ___CSS_LOADER_EXPORT___;
